/** Split display name into stem and extension (last dot only). */
export function splitFilename(filename: string): { base: string; ext: string } {
  const i = filename.lastIndexOf(".");
  if (i <= 0 || i === filename.length - 1) {
    return { base: filename, ext: "" };
  }
  return { base: filename.slice(0, i), ext: filename.slice(i) };
}
